(function () {
  const BADGE_SELECTOR = 'badge-list, .badge-list';
  const DEBUG = false;
  const PRELOAD_NEXT = 10;

  // Inject styles for 5% Extra badge
  if (!document.getElementById('badge-5-extra-styles')) {
    const style = document.createElement('style');
    style.id = 'badge-5-extra-styles';
    style.textContent = `
      .badge--5-extra {
        background: #edeae7 !important;
        color: #9a1c2e !important;
        font-weight: 700 !important;
      }
    `;
    document.head.appendChild(style);
  }

  const slugify = (str) => {
    try {
      return String(str)
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'badge';
    } catch {
      return 'badge';
    }
  };

  // Prioritäten: kleinere Zahl = weiter vorne
  const PRIORITY = {
    sale: 1,
    'free-gift': 2,
    'daily-deal': 3,
    bestseller: 4,
    'new-in': 5,
    default: 99
  };

  const FAILSAFE_MS = 5000;

  function forceRemoveAllBadgeSkeletons() {
    document.querySelectorAll(BADGE_SELECTOR + ':not(.loaded)').forEach(function (el) {
      try { updateBadge(el); } catch (e) {
        el.innerHTML = '';
        el.classList.remove('badge-list--skeleton');
        el.classList.add('loaded');
      }
    });
    document.querySelectorAll('.badge-list--skeleton').forEach(function (el) {
      el.classList.remove('badge-list--skeleton');
    });
  }

  function waitForRosentalDiscount(callback, attempts = 0) {
    if (window.RosentalDiscount?.getCartConfiguration) {
      const config = window.RosentalDiscount.getCartConfiguration();
      if (config && config.cart) {
        callback();
        return;
      }
    }
    if (attempts < 10) {
      setTimeout(() => waitForRosentalDiscount(callback, attempts + 1), 100);
    } else {
      callback();
    }
  }

  function makeBadgeEl({ classNames, html, text, style }) {
    const el = document.createElement('span');
    el.className = classNames;
    if (style && typeof style === 'object') {
      Object.keys(style).forEach(k => {
        if (style[k]) el.style.setProperty(k, style[k], 'important');
      });
    }
    if (html) el.innerHTML = html;
    else el.textContent = text || '';
    return el;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateBadge(wrapper) {
    if (!wrapper || wrapper.classList.contains('loaded')) return;

    try { _updateBadgeInner(wrapper); } catch (e) {
      if (DEBUG) console.warn('[badge-list] updateBadge failed', e);
      wrapper.innerHTML = '';
      wrapper.classList.remove('badge-list--skeleton');
      wrapper.classList.add('loaded');
    }
  }

  function _updateBadgeInner(wrapper) {
    wrapper.innerHTML = '';
    wrapper.classList.remove('badge-list--skeleton');
    wrapper.classList.add('loaded');

    const productId = parseInt(wrapper.dataset.productId);
    const price = parseFloat(wrapper.dataset.productPrice || '0');
    const compare = parseFloat(wrapper.dataset.productCompare || '0');
    const collections = JSON.parse(wrapper.dataset.collections || '[]').map(String);
    const available = wrapper.dataset.available === 'true';
    const continueSelling = wrapper.dataset.continue === 'true';
    const context = (wrapper.dataset.context || '').trim() || 'default';
    const isCardContext = context === 'card' || context === 'collection';
    const isSet = wrapper.dataset.isSet === 'true';
    
    // Check if 5% Extra is active to determine badge limit
    let visibleLimit = Infinity;
    if (isCardContext) {
      try {
        const activeDiscount = window.RosentalDiscount?.getActiveDiscount?.();
        visibleLimit = (activeDiscount && activeDiscount.show_5_extra) ? 3 : 2;
      } catch (e) {
        visibleLimit = 2; // Default to 2 if check fails
      }
    }

    // Sold out: single badge, return early
    if (!available && !continueSelling) {
      const soldOut = makeBadgeEl({
        classNames: `badge badge--sold-out badge-${slugify('Ausverkauft')}`,
        text: 'Ausverkauft'
      });
      wrapper.appendChild(soldOut);
      return;
    }

    // Sammle alle möglichen Badges in einem Array und sortiere am Ende
    const badges = [];

    // 1) Custom Badges aus Metafeld (neue Source: custom.badges_new → Metaobjekte)
    try {
      const raw = JSON.parse(wrapper.dataset.badges || '[]');
      const badgeData = Array.isArray(raw) ? raw : [];
      badgeData.forEach(entry => {
        // Unterstützt sowohl neues Objekt-Format {label,bg,color,icon} als auch
        // altes String-Format (als Sicherheit, falls irgendwo noch Strings landen)
        let label = '';
        let bg = '';
        let color = '';
        let icon = '';
        if (typeof entry === 'string') {
          label = entry.trim();
        } else if (entry && typeof entry === 'object') {
          label = (entry.label || '').toString().trim();
          bg = (entry.bg || '').toString().trim();
          color = (entry.color || '').toString().trim();
          icon = (entry.icon || '').toString().trim();
        }
        if (!label) return;

        const slug = slugify(label);
        // Priority-Mapping für bekannte Labels
        let prio = PRIORITY.default;
        if (slug === 'daily-deal') prio = PRIORITY['daily-deal'];
        else if (slug === 'bestseller') prio = PRIORITY.bestseller;
        else if (slug === 'new-in' || slug === 'neu') prio = PRIORITY['new-in'];

        // Flat-Style nur wenn background_color gesetzt ist → Glass/Shadow entfernen
        const isFlat = !!bg;
        const classNames = [
          'badge',
          'badge--custom',
          `badge-${slug}`,
          isFlat ? 'badge--custom-flat' : ''
        ].filter(Boolean).join(' ');

        const style = {};
        if (bg) style.background = bg;
        if (color) style.color = color;

        let html = '';
        if (icon) {
          html += `<img class="badge__icon" src="${escapeHtml(icon)}" alt="" loading="lazy" width="16" height="16">`;
        }
        html += `<span class="badge__label">${escapeHtml(label)}</span>`;

        badges.push({
          key: slug,
          priority: prio,
          el: makeBadgeEl({
            classNames: classNames,
            html: html,
            style: style
          })
        });
      });
    } catch (e) {
      if (DEBUG) console.warn('[badge-list] Invalid JSON for custom badges', e);
    }

    // 2) FREE GIFT
    let isFreeGift = false;
    try {
      const config = window.RosentalDiscount?.getCartConfiguration?.();
      const activeDiscount = config?.activeDiscount;
      if (activeDiscount?.free_gift?.products?.includes(productId)) {
        isFreeGift = true;
      }
    } catch (e) {
      if (DEBUG) console.warn('[badge-list] Free gift check failed:', e);
    }

    if (isFreeGift) {
      badges.push({
        key: 'free-gift',
        priority: PRIORITY['free-gift'],
        el: makeBadgeEl({
          classNames: 'badge badge--free-gift badge-free-gift',
          text: '🎁 FREE GIFT'
        })
      });
    }

    // 3) SALE (nur wenn NICHT Free Gift aktiv)
    const tier = window.RosentalDiscount?.findDiscountTier?.(productId, collections);
    const config = window.RosentalDiscount?.getCartConfiguration?.();
    const code = config?.activeCode;

    const tagIconSvg = `<svg class="icon icon__tag" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 1em; height: 1em; display: inline-block; vertical-align: middle; fill: white;"><path d="M11.304 1.446a1.75 1.75 0 0 1 1.58.478l-8.971 1m7.652.509L4.788 4.788l-1.355 6.777 9.521 9.52 8.132-8.13-9.521-9.522Zm-.261-1.987L3.742 2.958l7.562-1.512Zm1.58.478 9.793 9.793a1.75 1.75 0 0 1 0 2.474l-8.486 8.486a1.75 1.75 0 0 1-2.474 0l-9.793-9.793a1.75 1.75 0 0 1-.478-1.58l1.512-7.562a1 1 0 0 1 .784-.784" fill-rule="evenodd" clip-rule="evenodd"></path><path d="M7.874 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"></path></svg>`;

    const makeSaleHtml = (discountText, showCode, hasTier) => {
      let html = '';
      
      // Add tag icon if discount code is active and product is in a tier
      // If tag icon is shown, "Set" text is not displayed (icon has priority)
      const showTagIcon = hasTier && code;
      
      if (showTagIcon) {
        html += tagIconSvg + ' ';
      }
      
      // Add "Set" prefix if product is a set (only if tag icon is not shown)
      if (isSet && !showTagIcon) {
        html += `<strong>Set</strong> `;
      }
      
      html += `<strong>${discountText}</strong>`;
      
      if (showCode) {
        html += ` Code: <strong>${code || 'NONE'}</strong>`;
      }
      
      return html;
    };

    if (!isFreeGift) {
      if (tier) {
        const priceBaseOnPrice =
          tier.applies_to_price === true ||
          tier.applies_to_price === 'true' ||
          tier.applies_to_price === 1 ||
          tier.applies_to_price === '1';

        const rabattBasis = priceBaseOnPrice ? price : compare;
        let finalPrice;
        let discountText;
        
        if (tier.type === 'percentage') {
          finalPrice = rabattBasis * (1 - tier.value / 100);
          const percent = compare > 0 ? Math.round(((compare - finalPrice) / compare) * 100) : 0;
          discountText = `-${percent}%`;
        } else if (tier.type === 'fixed') {
          finalPrice = Math.max(0, rabattBasis - tier.value);
          // Fixed discount: value is in cents, convert to euros for display
          const fixedAmount = tier.value / 100;
          discountText = `-${fixedAmount.toFixed(2)}€`;
        } else {
          finalPrice = price;
          const percent = compare > 0 ? Math.round(((compare - finalPrice) / compare) * 100) : 0;
          discountText = `-${percent}%`;
        }

        badges.push({
          key: 'sale',
          priority: PRIORITY.sale,
          el: makeBadgeEl({
            classNames: 'badge badge--on-sale badge-sale',
            html: makeSaleHtml(discountText, context === 'product', true)
          })
        });
      } else if (compare > price) {
        const percent = Math.round(((compare - price) / compare) * 100);
        badges.push({
          key: 'sale',
          priority: PRIORITY.sale,
          el: makeBadgeEl({
            classNames: 'badge badge--on-sale badge-sale',
            html: makeSaleHtml(`-${percent}%`, false, false)
          })
        });
      }
    }

    // 4) 5% EXTRA Badge (separate badge with white background)
    try {
      const activeDiscount = window.RosentalDiscount?.getActiveDiscount?.();
      if (activeDiscount && activeDiscount.show_5_extra) {
        badges.push({
          key: '5-extra',
          priority: PRIORITY.sale + 0.5, // Show right after sale badge
          el: makeBadgeEl({
            classNames: 'badge badge--5-extra badge-5-extra',
            text: '-5% EXTRA'
          })
        });
      }
    } catch (e) {
      if (DEBUG) console.warn('[badge-list] 5% Extra badge check failed:', e);
    }

    // 5) Sortieren nach Priority und rendern mit Limit
    badges
      .sort((a, b) => a.priority - b.priority)
      .slice(0, visibleLimit)
      .forEach(b => wrapper.appendChild(b.el));
  }

  function updateAllBadges() {
    const allBadges = Array.from(
      document.querySelectorAll(`${BADGE_SELECTOR}:not(.loaded)`)
    );

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const index = allBadges.indexOf(el);
          if (index === -1) return;

          updateBadge(el);
          obs.unobserve(el);

          const preloadNext = allBadges.slice(index + 1, index + 1 + PRELOAD_NEXT);
          preloadNext.forEach(next => {
            updateBadge(next);
            obs.unobserve(next);
          });
        });
      },
      { threshold: 0.1 }
    );

    allBadges.forEach(el => {
      observer.observe(el);
      setTimeout(() => {
        if (!el.classList.contains('loaded')) {
          updateBadge(el);
          observer.unobserve(el);
        }
      }, 2000);
    });
  }

  function observeDynamicBadges() {
    if (!document.body) {
      // Warte bis document.body verfügbar ist
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observeDynamicBadges);
        return;
      }
      // Fallback: versuche es nach kurzer Verzögerung erneut
      setTimeout(observeDynamicBadges, 100);
      return;
    }
    
    const mo = new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.(BADGE_SELECTOR)) updateBadge(node);
          node.querySelectorAll?.(BADGE_SELECTOR).forEach(updateBadge);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function reinitializeBadgesSoon() {
    if (reinitializeBadgesSoon._t) clearTimeout(reinitializeBadgesSoon._t);
    const run = () => {
      try {
        document
          .querySelectorAll(`${BADGE_SELECTOR}.loaded`)
          .forEach(el => el.classList.remove('loaded'));
        updateAllBadges();
      } catch (e) {
        if (DEBUG) console.warn('[badge-list] Reinit failed', e);
      }
    };
    reinitializeBadgesSoon._t = setTimeout(() => {
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(() => requestAnimationFrame(run));
      } else {
        run();
      }
    }, 0);
    reinitializeBadgesSoon._t2 && clearTimeout(reinitializeBadgesSoon._t2);
    reinitializeBadgesSoon._t2 = setTimeout(run, 300);
  }

  function initOnce() {
    window.addEventListener('cart-config:update', () => {
      document
        .querySelectorAll(`${BADGE_SELECTOR}.loaded`)
        .forEach(el => el.classList.remove('loaded'));
      updateAllBadges();
    });

    document.addEventListener('facet:update', reinitializeBadgesSoon, true);
    document.addEventListener('theme:loading:end', reinitializeBadgesSoon, true);
    document.addEventListener('shopify:section:load', reinitializeBadgesSoon, true);

    updateAllBadges();
    observeDynamicBadges();
  }

  // Varianten-Switch: Badge-Daten aktualisieren + neu rendern
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const formId = event.detail?.formId;
    const form = formId ? (typeof formId === 'string' ? document.forms[formId] : formId) : null;
    let wrappers = [];
    if (form) {
      const c = form.closest('.product, .quick-buy, product-info, [data-product]') || form.closest('section');
      if (c) wrappers = Array.from(c.querySelectorAll(`${BADGE_SELECTOR}[data-product-id]`));
    }
    if (!wrappers.length && variant.product_id) {
      wrappers = Array.from(document.querySelectorAll(`${BADGE_SELECTOR}[data-product-id="${variant.product_id}"]`));
    }
    wrappers.forEach(el => {
      el.dataset.productPrice = variant.price || 0;
      el.dataset.productCompare = variant.compare_at_price || 0;
      el.dataset.available = variant.available ? 'true' : 'false';
      el.dataset.continue = (variant.inventory_policy === 'continue') ? 'true' : 'false';

      // isSet aus vorberechneter Map (Metafields nicht im Event verfügbar)
      let newSetPrice = 0;
      try {
        const map = JSON.parse(el.dataset.variantSetMap || '{}');
        newSetPrice = map[String(variant.id)] || 0;
      } catch (e) {}
      const isProductSet = el.dataset.isProductSet === 'true';
      el.dataset.isSet = (isProductSet || newSetPrice > 0) ? 'true' : 'false';

      // Re-render
      el.classList.remove('loaded');
      updateBadge(el);
    });
  });

  var badgeFailsafeTimer = setTimeout(forceRemoveAllBadgeSkeletons, FAILSAFE_MS);
  waitForRosentalDiscount(function () {
    clearTimeout(badgeFailsafeTimer);
    initOnce();
  });
})();
